// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("rescript/lib/js/belt_List.js");

var formatKeys = {
  hd: "email",
  tl: {
    hd: "phone_digits",
    tl: {
      hd: "numeric",
      tl: {
        hd: "alphanumeric",
        tl: {
          hd: "iso_date",
          tl: /* [] */0
        }
      }
    }
  }
};

function formatLabel(key) {
  switch (key) {
    case "alphanumeric" :
        return "Letters and numbers only";
    case "email" :
        return "Email address";
    case "iso_date" :
        return "Date (YYYY-MM-DD)";
    case "numeric" :
        return "Digits only";
    case "phone_digits" :
        return "Phone number";
    default:
      return key;
  }
}

function regexForFormat(key) {
  switch (key) {
    case "alphanumeric" :
        return "[a-zA-Z0-9]+";
    case "email" :
        return "[^@\\s]+@[^@\\s]+\\.[^@\\s]+";
    case "iso_date" :
        return "\\d{4}-\\d{2}-\\d{2}";
    case "numeric" :
        return "\\d+";
    case "phone_digits" :
        return "\\+?[\\d\\s\\-()]{7,20}";
    default:
      return "";
  }
}

function isValidFormat(key) {
  return Belt_List.has(formatKeys, key, (function (a, b) {
                return a === b;
              }));
}

exports.formatKeys = formatKeys;
exports.formatLabel = formatLabel;
exports.regexForFormat = regexForFormat;
exports.isValidFormat = isValidFormat;
/* No side effect */
